export default "__VITE_ASSET__DOP2t_Kc__"